export default __webpack_public_path__ + "static/media/dinner1.cdc73803.png";